import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PortalAccountsTable from './portal-accounts-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-portal-admin-portal-company-admins')) {
  ReactDOM.render(<PortalAccountsTable
    url= "/api/v1/portal/portal-admin/portal-company-admins"
    message_if_none = 'No portal company admins yet.'
  />,
document.getElementById('react-component-g4-logistics-portal-portal-admin-portal-company-admins'));
}
